import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ToastService } from './../../../utils/toast.service';
import { ErrorsService } from './../../../services/errors.service';
import { RoomsService } from 'src/app/services/rooms/rooms.service';
import { IRoom } from 'src/app/models/rooms';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {
  inProcess = false
  nextRoom: string | null = null
  @Output() loadRooms = new EventEmitter();
  @Input() rooms: IRoom[] = []
  @Input() selectedRoom: IRoom | null = null
  @Input() student: any = null

  constructor(
    private modalService: NgbModal,
    private roomService: RoomsService,
    private errorsService: ErrorsService,
    private toastService: ToastService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
  }

  open(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title', centered: true,
    })
  }

  editStudent() {
    this.inProcess = true
    this.toastService.showLoaderModal(
      this.translate.instant('shared-components.edit-user.modal-loading-title'),
      ''
    );
    const data = {
      room_id: this.nextRoom,
      current_room_id: this.selectedRoom!.id
    }
    this.roomService.moveStudent(data, this.student.id).subscribe({
      next: () => {
        this.inProcess = false
        this.toastService.closeLoader();
        this.loadRooms.emit()
        this.modalService.dismissAll()
      },
      error: (e) => {
        this.inProcess = false
        this.toastService.closeLoader();
        this.errorsService.handleErrors(e)
      },
    })
  }
  getRooms() {

  }
}
